import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ErrorComponent } from '@bo-client/shared/error/error.component';
import { Route } from '@bo-client/core';
import { LandingPageComponent } from '@bo-client/core/landing-page/landing-page.component';
import { path } from '@bo-client/shared/constants/path';
import { TermsConditionsComponent } from '@bo-client/shared/components/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from '@bo-client/shared/components/privacy-policy/privacy-policy.component';
import { UserLoggedInGuard } from '@bo-client/core/guards/user-logged-in-guard.service';
import { TmValidateInstallerPassComponent } from '@bo-client/technician-management/tm-validate-installer-pass/tm-validate-installer-pass.component';
import { PortalConfigurationPageComponent } from '@bo-client/portal-configuration-page/portal-configuration-page.component';

// Add template management path prefix
path.templateManagementPrefix = 'template-management';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },

  /**
   * we need to keep those for downwards compatability-reasons
   */
  {
    path: path.external + '/' + path.cmFCContractConfirmation + path.id + path.token,
    redirectTo: path.cmPrefix + '/' + path.cmFCContractConfirmation + path.id + path.token
  },
  {
    path: path.external + '/' + path.cmCRChimneySweepConfirmation + path.id + path.token,
    redirectTo: path.cmPrefix + '/' + path.cmCRChimneySweepConfirmation + path.id + path.token
  },
  {
    path: path.external + '/' + path.cmGRPlaceInServiceConfirmation + path.id + path.token,
    redirectTo: path.cmPrefix + '/' + path.cmGRPlaceInServiceConfirmation + path.id + path.token
  },
  {
    path: path.external + '/' + path.cmGRConfirmFeedinOrder + path.id + path.token,
    redirectTo: path.cmPrefix + '/' + path.cmGRConfirmFeedinOrder + path.id + path.token
  },
  {
    path: path.external + '/' + path.cmGridRegistration + path.gridRegType + path.create,
    redirectTo: path.cmPrefix + '/' + path.cmGridRegistration + path.gridRegType + path.create
  },
  {
    path: path.external + '/' + path.grAssignTechnician + path.id + path.token,
    redirectTo: path.cmPrefix + '/' + path.grAssignTechnician + path.id + path.token
  },
  {
    path: path.external + '/' + path.hapApproval + path.id + path.token,
    redirectTo: path.hapPrefix + '/' + path.hapApproval + path.id + path.token
  },
  {
    path: path.tmValidatePass,
    component: TmValidateInstallerPassComponent
  },
  {
    path: 'routes',
    component: PortalConfigurationPageComponent
  },
  Route.withShellExternal([
    {
      path: 'home',
      canActivate: [UserLoggedInGuard],
      component: LandingPageComponent
    },
    {
      path: path.termsConditions,
      component: TermsConditionsComponent
    },
    {
      path: path.privacyPolicy,
      component: PrivacyPolicyComponent
    },
    {
      path: path.external,
      loadChildren: () => import('./external.module').then((m) => m.ExternalModule)
    }
  ]),
  {
    path: path.hapPrefix,
    loadChildren: () => import('./nap/nap.module').then((m) => m.NapModule)
  },
  {
    path: path.cssPrefix,
    loadChildren: () => import('./css/css.module').then((m) => m.CssModule)
  },
  {
    path: path.tmPrefix,
    loadChildren: () =>
      import('./technician-management/technician-management.module').then((m) => m.TechnicianManagementModule)
  },
  {
    path: path.hapPrefix,
    loadChildren: () => import('./user-management/user-management.module').then((m) => m.UserManagementModule)
  },
  {
    path: path.hapTenantPrefix,
    loadChildren: () =>
      import('./tenant-management/tenant-management.module').then((m) => m.TenantManagementModule)
  },
  {
    path: path.priceCalculationPrefix,
    loadChildren: () =>
      import('./price-calculation/price-calculation.module').then((m) => m.PriceCalculationModule)
  },
  {
    path: path.addressSensePrefix,
    loadChildren: () => import('./address-sense/address-sense.module').then((m) => m.AddressSenseModule)
  },
  {
    path: path.cmPrefix,
    loadChildren: () =>
      import('./activation-management/commissioning-management.module').then(
        (m) => m.CommissioningManagementModule
      )
  },
  {
    path: path.templateManagementPrefix,
    loadChildren: () =>
      import('./template-management/template-management.module').then((m) => m.TemplateManagementModule)
  },
  { path: 'error', component: ErrorComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
      enableTracing: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
